import { ProfileContext } from 'contexts/ProfileContext';
import { useContext } from 'react';

const useProfile = () => useContext(ProfileContext);
export default useProfile;
